const productNotFound = require('./productNotFound');

module.exports = {
  productNotFound
};
